// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1057f3dc","239":"931ae9e1","488":"5f5932e9","667":"cc733895"}[chunkId] + ".chunk.js";
};